import axios from "axios";
import { create } from "zustand";

export let useMessages = create((set, get) => ({
    messages: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "FISH",
            dataIndex: "fullname",
            key: "fullname",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Telefon",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "Xabar",
            dataIndex: "message",
            key: "message",
        }
    ],
    getMessages: () => {
        axios.get("/messages")
            .then(res => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({messages: data});
            })
            .catch((err) => {
                console.error('Xabarlarni yuklab olishda xatolik:', err);
                set({messages: []});
            })
    },
    deleteMessage: (id) => {
        axios.delete(`/messages/${id.id}`)
            .then(res => get().getMessages())
            .catch((err) => {
                console.error('Xabarni o\'chirishda xatolik:', err);
            })
    },
}))